import {IVariantOption} from 'PyzShopUi/scripts/product-detail-page/interfaces';

export default class ProductVariantDataHandler {
    public static init = (): any => {
        const variantListRows = document.querySelectorAll('.article-all-variants [data-concrete-id]');
        const variantData = {};

        Array.from(variantListRows).forEach((row: HTMLElement) => {
            variantData[row?.dataset?.concreteId] = ProductVariantDataHandler.getArticleVariant(row);
        });

        return variantData;
    }

    public static getArticleAllVariants = (): Map<string, IVariantOption> => {
        const variantListRows = document.querySelectorAll('.article-all-variants [data-concrete-id]');
        const variantMap: Map<string, IVariantOption> = new Map();

        Array.from(variantListRows).forEach((row: HTMLElement) => {
            const variant = ProductVariantDataHandler.getArticleVariant(row);
            variantMap.set(row?.dataset?.concreteId.toString(), variant);
        });

        return variantMap;
    }

    protected static getArticleVariant = (row: HTMLElement): IVariantOption => {
        const variantNameElement: HTMLElement = row.querySelector('[data-variant-name]');
        const variantSkuElement: HTMLElement = row.querySelector('[data-sku]');
        const variantOptionNameElement: HTMLElement = row.querySelector('[data-variant-option-name]');

        return {
            variantName: variantNameElement?.dataset?.variantName,
            fullName: variantNameElement?.innerText,
            sku: variantSkuElement?.dataset?.sku,
            optionSelectName: variantOptionNameElement?.dataset?.variantOptionName,
        };
    }
}
